/*
 * domready (c) Dustin Diaz 2014 - License MIT
 */
// @formatter:off
// prettier-ignore
!function (e, t) {
  "undefined" != typeof module ? module.exports = t() : "function" == typeof define && "object" == typeof define.amd ? define(t) : this[e] = t()
}("domready", function () {
  var e, t = [], o = "object" == typeof document && document, n = o && o.documentElement.doScroll,
    d = "DOMContentLoaded", f = o && (n ? /^loaded|^c/ : /^loaded|^i|^c/).test(o.readyState);
  return !f && o && o.addEventListener(d, e = function () {
    for (o.removeEventListener(d, e), f = 1; e = t.shift();) e()
  }), function (e) {
    f ? setTimeout(e, 0) : t.push(e)
  }
});
// @formatter:on



/**
 * Minimalistische JSONP-Funktion in Vanilla-JS
 * Erwartet, dass die URL den Parameter &c=CALLBACK_NAME enthält,
 * sodass Mailchimp damit seinen Callback aufruft.
 */
function jsonp(url) {
  return new Promise(function (resolve, reject) {
    // Callback-Namen aus der URL auslesen (Parameter c=...)
    const callbackParamMatch = url.match(/c=([^&]+)/);
    if (!callbackParamMatch) {
      reject("Kein Callback-Parameter (c=...) in der URL gefunden");
      return;
    }
    // Beispiel: c=jQuery191023746235_167888575
    const callbackName = callbackParamMatch[1];

    // Globale Callback-Funktion definieren
    window[callbackName] = function (data) {
      resolve(data);
      // Aufräumen
      delete window[callbackName];
      document.body.removeChild(script);
    };

    // Dynamisch ein <script>-Tag mit src=... einfügen
    const script = document.createElement("script");
    script.src = url;
    script.onerror = function () {
      reject("Das JSONP-Skript konnte nicht geladen werden.");
    };
    document.body.appendChild(script);
  });
}

/**
 * iOS WebView Detector
 * Detects if the website is running inside an iOS app's WebView
 * Based on real-world app data from iPhone with iOS 18.7
 *
 * @version 1.0.0
 * @license MIT
 */

const iOSWebViewDetector = {

  /**
   * Main detection function
   * Returns detailed information about WebView status
   *
   * @returns {Object} Detection result with confidence score
   */
  detect() {
    if (!this.isIOS()) {
      return {
        isWebView: false,
        platform: 'not-ios',
        confidence: 0,
        signals: []
      };
    }

    const detection = this.analyzeIOSWebView();

    return {
      isWebView: detection.confidence >= 50,
      platform: 'ios',
      confidence: detection.confidence,
      signals: detection.signals
    };
  },

  /**
   * Check if device is iOS
   * Covers iPhone, iPad, and iPadOS (which reports as Mac)
   *
   * @returns {boolean}
   */
  isIOS() {
    const ua = navigator.userAgent;
    const platform = navigator.platform;

    // Standard iOS devices
    if (/iPhone|iPad|iPod/.test(ua)) {
      return true;
    }

    // iPadOS 13+ reports as "MacIntel" but has touch support
    if (platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return true;
    }

    return false;
  },

  /**
   * Analyze iOS environment for WebView indicators
   * Each signal contributes to the confidence score (max 100)
   *
   * @returns {Object} Analysis result with confidence and signals
   */
  analyzeIOSWebView() {
    const signals = [];
    let confidence = 0;
    const ua = navigator.userAgent;

    // SIGNAL 1: Missing "Safari/" in User Agent (30 points)
    // Real Safari always includes "Safari/xxx.xx"
    // WebView UA: "...AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148"
    if (!/Safari\/[\d.]+/.test(ua) && /AppleWebKit/.test(ua)) {
      confidence += 30;
      signals.push({
        type: 'ua_missing_safari',
        weight: 30,
        description: 'User Agent lacks "Safari/" - typical WKWebView pattern'
      });
    }

    // SIGNAL 2: Missing "Version/" in User Agent (25 points)
    // Real Safari includes "Version/18.0" or similar
    // WebView does not include this
    if (!/Version\/[\d.]+/.test(ua) && /iPhone|iPad/.test(ua)) {
      confidence += 25;
      signals.push({
        type: 'ua_missing_version',
        weight: 25,
        description: 'User Agent lacks "Version/" - WKWebView indicator'
      });
    }

    // SIGNAL 3: window.webkit unavailable (20 points)
    // In the tested app: window.webkit does not exist
    // This can vary depending on how the app is configured
    if (typeof window.webkit === 'undefined') {
      confidence += 20;
      signals.push({
        type: 'webkit_missing',
        weight: 20,
        description: 'window.webkit object not available'
      });
    }

    // SIGNAL 4: ServiceWorker not available (15 points)
    // Safari 11.1+ supports ServiceWorker
    // WebViews often have this disabled
    if (!('serviceWorker' in navigator)) {
      confidence += 15;
      signals.push({
        type: 'no_service_worker',
        weight: 15,
        description: 'ServiceWorker API not available - WebView restriction'
      });
    }

    // SIGNAL 5: Notifications not available (10 points)
    // Another API often disabled in WebViews
    if (!('Notification' in window)) {
      confidence += 10;
      signals.push({
        type: 'no_notifications',
        weight: 10,
        description: 'Notifications API not available'
      });
    }

    // BONUS: Detect standalone mode (PWA)
    // This is NOT a WebView, but worth noting
    if (navigator.standalone === true) {
      signals.push({
        type: 'standalone_mode',
        weight: 0,
        description: 'Running in PWA standalone mode (not a WebView)'
      });
      // Reduce confidence as this is a PWA, not a WebView
      confidence = Math.max(0, confidence - 20);
    }

    return {
      confidence: Math.min(confidence, 100),
      signals: signals
    };
  },

  /**
   * Simple boolean check
   * Recommended for most use cases
   *
   * @returns {boolean} true if running in iOS WebView
   */
  isWebView() {
    return this.detect().isWebView;
  },

  /**
   * Get detailed debug information
   * Useful for troubleshooting and logging
   *
   * @returns {Object} Comprehensive detection info
   */
  getDebugInfo() {
    const detection = this.detect();

    return {
      // Detection results
      ...detection,

      // Environment details
      environment: {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        vendor: navigator.vendor,
        maxTouchPoints: navigator.maxTouchPoints,
        standalone: navigator.standalone,
        language: navigator.language
      },

      // Feature availability
      features: {
        webkit: typeof window.webkit !== 'undefined',
        serviceWorker: 'serviceWorker' in navigator,
        notifications: 'Notification' in window,
        share: 'share' in navigator,
        geolocation: 'geolocation' in navigator
      },

      // Screen info
      screen: {
        width: screen.width,
        height: screen.height,
        availWidth: screen.availWidth,
        availHeight: screen.availHeight,
        pixelRatio: window.devicePixelRatio
      }
    };
  }
};

/*
 * Fügt <body data-page="…"> anhand der aktuellen URL hinzu.
 *  - "/"           → data-page="index"
 *  - "/pages/xyz"  → data-page="xyz"
 *  - "/collections/fruits" → data-page="fruits"
 *  - "/products/apple-juice" → data-page="apple-juice"
 *
 *  Kann gefahrlos in allen Themes laufen, da er nur liest & setzt.
 */
domready(() => {
  // Hide mobile navigation bar on iOS WebViews, when website is being displayed inside our uscreen video app
  const iosWebViewInfo = iOSWebViewDetector.detect();
  if (iosWebViewInfo.isWebView) {
    const headerMobileButtonElement = document.querySelector('.header__mobile__button');
    headerMobileButtonElement.style.display = "none";
  }

  // Pfad ohne führenden/abschließenden Slash holen
  const path = window.location.pathname.replace(/^\/|\/$/g, '');

  // Standardwert für die Startseite
  let pageHandle = 'index';

  if (path.length) {
    // Letzten Segment-Slug extrahieren
    pageHandle = path.split('/').pop();
  }

  // Attribut setzen, falls noch nicht vorhanden
  if (!document.body.dataset.page) {
    document.body.setAttribute('data-page', pageHandle);
  }

  // Unmute mobile videos when at least 50% visible and reset when leaving
  /*
  const mobileVideos = document.querySelectorAll('.js-vwp-mobile-video');
  mobileVideos.forEach((video) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.5) {
          video.muted = false;
          video.play();
        } else {
          video.muted = true;
          video.currentTime = 0;
        }
      });
    }, { threshold: [0, 0.5] });
    observer.observe(video);
  });
*/

    // Scroll controlled sound and playback for videos with product
    const groups = {};
    const states = new Map();

    function updateGroup(group, enabled) {
      const data = groups[group];
      if (!data) return;
      data.enabled = enabled;
      data.items.forEach((s) => {
        s.enabled = enabled;
        s.video.muted = !enabled;
        s.buttons.forEach((b) => { b.dataset.sound = enabled ? 'on' : 'off'; });
        if (enabled && s.ratio >= 0.5) {
          s.video.play().catch(() => {});
        }
      });
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const state = states.get(entry.target);
        if (!state) return;
        state.ratio = entry.intersectionRatio;
        if (state.ratio >= 0.5) {
          entry.target.play().catch(() => {});
          entry.target.muted = !state.enabled;
        } else if (state.ratio <= 0.25) {
          entry.target.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.5] });

    document.querySelectorAll('.section-video-with-product').forEach((section) => {
      const videos = [...section.querySelectorAll('video')];
      const buttons = [...section.querySelectorAll('.vwp__audio-toggle')];
      if (!videos.length || !buttons.length) return;
      const group = section.dataset.group || '';

      videos.forEach((video) => {
        video.controls = false;
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.preload = 'metadata';
        const state = { video, buttons, ratio: 0, enabled: false, group };
        states.set(video, state);
        if (group) {
          if (!groups[group]) groups[group] = { enabled: false, items: [] };
          groups[group].items.push(state);
        }
        io.observe(video);
      });

      buttons.forEach((b) => { b.dataset.sound = 'off'; });

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (group) {
            updateGroup(group, !groups[group].enabled);
          } else {
            const firstState = states.get(videos[0]);
            const newEnabled = !firstState.enabled;
            videos.forEach((video) => {
              const s = states.get(video);
              if (!s) return;
              s.enabled = newEnabled;
              video.muted = !newEnabled;
            });
            buttons.forEach((b) => { b.dataset.sound = newEnabled ? 'on' : 'off'; });
            const activeVideo = videos.find((v) => (states.get(v)?.ratio ?? 0) >= 0.5);
            if (newEnabled && activeVideo) activeVideo.play().catch(() => {});
          }
        });
      });
    });
});
